export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/70">
      <div className="w-full px-6 md:px-10 py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            {/* Brand */}
            <div className="sm:col-span-2 lg:col-span-1">
              <a href="#hero" className="flex items-center gap-2 no-underline mb-4">
                <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-fill text-background-50 text-lg"></i>
                </span>
                <span className="font-heading text-2xl text-background-50 tracking-wide">
                  黑料大赛
                </span>
              </a>
              <p className="text-sm text-foreground-400 leading-relaxed max-w-[280px]">
                最火八卦热度排行榜，全网黑料排名、网红爆料追踪、热搜事件盘点，一网打尽热门爆料。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {[
                  { label: '热门专题', href: '#cards' },
                  { label: '最新快讯', href: '#updates' },
                  { label: '网友辣评', href: '#comments' },
                  { label: '话题热度榜', href: '#topics' },
                  { label: '黑料热度榜', href: '#ranking' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Service */}
            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">服务与支持</h4>
              <ul className="space-y-2.5">
                {[
                  { label: '投稿爆料', href: '#contact' },
                  { label: '常见问答', href: '#faq' },
                  { label: '关于我们', href: '#about' },
                  { label: '平台特色', href: '#features' },
                  { label: '移动端入口', href: '#app' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Partners */}
            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                诚邀优质媒体与内容平台加入合作生态，共同打造最具影响力的八卦热度排行榜。
              </p>
            </div>
          </div>

          {/* Bottom */}
          <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 黑料大赛. 本站内容仅供娱乐参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span>隐私政策</span>
              <span>用户协议</span>
              <span>免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}